import { managementFeeBillConstants } from "@constants";

const initalState = {
  query: {
    loading: false,
    constructionUuid: null,
    condition: {},
    total: 0,
    items: [],
    fail: null
  }
};

export const managementFeeBills = (state = initalState, action) => {
  switch (action.type) {
    case managementFeeBillConstants.GET_ALL_REQUEST:
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: true
        }
      };
    case managementFeeBillConstants.GET_ALL_SUCCESS:
      const {
        total,
        statistics,
        config,
        community_bank_account,
        items,
        condition,
        constructionUuid
      } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          constructionUuid,
          condition,
          total,
          statistics,
          config,
          community_bank_account,
          items
        }
      };
    case managementFeeBillConstants.GET_ALL_FAILURE:
      const { error } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          fail: error
        }
      };
    case managementFeeBillConstants.RESET_ALL_SUCCESS:
      return initalState;
    default:
      return state;
  }
};
